import axios, { AxiosResponse } from "axios";
import { IDestination } from "../models/destination";
import { IPortDocument } from "../models/portDocument";

/** Dispatcher: list port-information entries for a destination. */
export const getPortDocumentsDisp = async (
    destinationId: string,
): Promise<AxiosResponse<IPortDocument[]>> => {
    return await axios.get(`/dispatcher/destination/${destinationId}/portDocuments`);
};

/** Dispatcher: create (id empty) or update (id set) a port-information entry. */
export const savePortDocumentDisp = async (
    destinationId: string,
    portDocument: IPortDocument,
): Promise<AxiosResponse<IDestination>> => {
    return await axios.post("/dispatcher/destination/portDocument", {
        destinationId,
        portDocument,
    });
};

/** Dispatcher: delete a port-information entry by id. */
export const deletePortDocumentDisp = async (
    destinationId: string,
    portDocumentId: string,
): Promise<AxiosResponse<IDestination>> => {
    return await axios.delete("/dispatcher/destination/portDocument", {
        data: { destinationId, portDocumentId },
    });
};

/** Locks &amp; Docks: read port-information entries published by the Dispatcher. */
export const getPortDocumentsDocks = async (
    destinationId: string,
): Promise<AxiosResponse<IPortDocument[]>> => {
    return await axios.get(`/docks/destination/${destinationId}/portDocuments`);
};
